module.exports = __webpack_public_path__ + "static/Blog-ebook-33c75114fbacfc1b02f956efc62fd85f.png";